import { PayloadAction } from '@reduxjs/toolkit';
import { message } from 'antd';
import { AxiosResponse } from 'axios';
import { downloadExcelFile } from 'features/Yucollect/utils/util';
import { put, takeLatest } from 'redux-saga/effects';
import {
  downloadSampleAllocation,
  downloadSampleAllocationFailure,
  downloadSampleAllocationSuccess,
  uploadFailure,
  uploadRequest,
  uploadSuccess,
} from 'redux/slice/allocation/UploadAllocation.slice';
import {
  IAllocationUploadResponse,
  IDownloadSampleAllocationRequest,
  UploadRequestPayload,
} from 'redux/types/Allocation.types';
import { allocationEndpoints } from 'services/api/endPoints';
import { HTTPClient } from 'services/api/http-client';

function* uploadFileAction({ payload }: PayloadAction<UploadRequestPayload>) {
  try {
    const { agencyId, formData } = payload;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const result: IAllocationUploadResponse = yield HTTPClient.PostRequest(
      `${allocationEndpoints.UPLOAD_ALLOCATION(agencyId)}`,
      formData
    );
    if (result?.status === 200) {
      yield put(uploadSuccess(result.data));
    }
  } catch (error: any) {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const error_msg = error?.response?.data?.message || error?.message;

    yield put(uploadFailure(error_msg));
  }
}
// Saga for downloading report
function* downloadSampleAllocationSaga(
  action: PayloadAction<IDownloadSampleAllocationRequest>
) {
  const { allocatorId, product, bucket, fileType } = action.payload;
  try {
    const payload = {
      allocatorId,
      product,
      bucket,
      fileType,
    };

    const response: AxiosResponse<Blob> = yield HTTPClient.PostRequest(
      allocationEndpoints.DOWNLOAD_SAMPLE_ALLOCATION(),
      payload,
      { responseType: 'blob' }
    );

    yield put(
      downloadSampleAllocationSuccess({
        status: '200',
        message: 'Download successful',
        warning: '',
        data: {
          allocation_id: '',
          product: [],
          bucket: [],
          allocation_name: '',
        },
      })
    );

    downloadExcelFile(response.data, `sample_allocation_${fileType}.xlsx`);

    message.success('Sample file downloaded successfully');
  } catch (error: any) {
    // Extract detailed error information
    const errorMessage = error?.response?.data?.message || 'Unknown error';
    const errorDetails =
      error?.response?.data?.details || 'No additional details';

    // Dispatch failure action with comprehensive error information
    yield put(
      downloadSampleAllocationFailure(`${errorMessage}: ${errorDetails}`)
    );

    // Show user-friendly error message using Ant Design message component
    message.error(`Failed to download sample file: ${errorMessage}`);
  }
}

export function* watchUploadFileSagas() {
  yield takeLatest(uploadRequest.type, uploadFileAction);
  yield takeLatest(downloadSampleAllocation.type, downloadSampleAllocationSaga);
}
